<div class="diwali-shopping max-w-screen-xl mx-auto p-2">
  <div class="container mx-auto px-4 py-8">
    <h2 class="diwali-section-title text-3xl font-semibold text-center mb-8">
      What are you shopping for today?
    </h2>

    <swiper-container
      #swiperContainer
      init="false"
      pagination="false"
      navigation="true"
      indicator="true"
      Autoplay="true"
      class="flex"
    >
      <swiper-slide
        class="diwali-category-slide rounded-lg overflow-hidden h-fit cursor-pointer"
        *ngFor="let catProductItem of subCategoriesProduct"
      >
        <div
          class="diwali-category-card bg-white dark:bg-white rounded-lg overflow-hidden"
          (click)="topSellingProduct(catProductItem._id)"
        >
          <h1
            class="diwali-category-name text-white text-center p-2 text-xs font-bold line-clamp-1"
          >
            {{ catProductItem.name }}
          </h1>
          <!-- <img [src]="catProductimgUrl+catProductItem.banner === '' ? 'https://w7.pngwing.com/pngs/656/22/png-transparent-shopping-centre-family-graphy-shoping-tshirt-people-toddler-thumbnail.png' : catProductimgUrl + catProductItem?.banner"   alt="Headless UI" class=" m-auto my-6"> -->
          <img
            [src]="catProductimgUrl + catProductItem?.imageUrl"
            [alt]="catProductItem.name"
            loading="lazy"
            decoding="async"
            class="diwali-category-image mb-2 w-full h-40 max-h-40 min-h-40"
          />

          <a
            class="diwali-shop-link inline-block text-center font-bold text-1xl p-2 w-full cursor-pointer rounded-lg"
            >Shop Now</a
          >
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>

<section class="diwali-popular px-6 py-8">
  <h2 class="diwali-section-title text-2xl font-semibold mb-6">
    Popular Product
  </h2>

  <div
    class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6"
  >
    <div
      *ngFor="let product of products"
      class="diwali-popular-card bg-white rounded-xl shadow-sm hover:shadow-lg transition duration-300 p-4 text-center cursor-pointer"
    >
      <div
        class="diwali-popular-image h-40 flex items-center justify-center mb-4"
        (click)="getProductById(product._id)"
      >
        <img
          [src]="catProductimgUrl + product.images[0]"
          [alt]="product.productDetails.productName"
          loading="lazy"
          decoding="async"
          class="max-h-full object-contain"
        />
      </div>

      <h3 class="text-sm font-medium truncate">
        {{ product?.productDetails?.productName }}
      </h3>

      <p class="diwali-popular-price font-semibold mt-1">
        From ₹{{ product?.priceInventoryShippingInfo?.sellingPrice }}
      </p>
    </div>
  </div>
</section>

<div class="grid grid-cols-12 gap-8 p-6 bg-white">
  <div class="col-span-12 lg:col-span-9">
    <div class="flex items-center gap-4 mb-8">
      <h2 class="text-2xl font-light text-gray-900 tracking-tight">
        Daily <span class="font-bold">Essentials</span>
      </h2>
      <div class="h-[1px] flex-grow bg-gray-100"></div>
      <button
        (click)="furntureProductList()"
        class="text-xs font-bold tracking-widest text-gray-400 hover:text-black transition-colors uppercase"
      >
        Browse All
      </button>
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
      <div
        *ngFor="let item of fetchDiscountedFurniture | slice: 0 : 4"
        class="group cursor-pointer"
        (click)="getProductById(item._id)"
      >
        <div
          class="relative aspect-square mb-4 bg-[#F3F4F6] rounded-2xl overflow-hidden flex items-center justify-center p-6"
        >
          <img
            [src]="catProductimgUrl + item?.images[0]"
            class="max-h-full max-w-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-110"
            [alt]="item.productDetails?.productName"
            loading="lazy"
            decoding="async"
          />

          <div
            class="absolute bottom-3 left-3 bg-white/90 backdrop-blur px-2 py-1 rounded-lg shadow-sm"
          >
            <span class="text-[10px] font-bold text-orange-600">
              -{{
                ((item?.priceInventoryShippingInfo?.MRP -
                  item?.priceInventoryShippingInfo?.sellingPrice) /
                  item?.priceInventoryShippingInfo?.MRP) *
                  100 | number: "1.0-0"
              }}%
            </span>
          </div>
        </div>

        <div class="text-center px-2">
          <h3
            class="text-sm font-medium text-gray-800 line-clamp-1 group-hover:text-blue-600 transition-colors"
          >
            {{ item.productDetails?.productName }}
          </h3>
          <div class="mt-1 flex items-center justify-center gap-2">
            <span class="text-sm font-bold text-gray-900"
              >₹{{ item?.priceInventoryShippingInfo?.sellingPrice }}</span
            >
            <span class="text-[11px] text-gray-400 line-through font-light"
              >₹{{ item?.priceInventoryShippingInfo?.MRP }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-span-12 lg:col-span-3">
    <div
      class="group relative h-full min-h-[400px] rounded-3xl overflow-hidden bg-gray-950 flex flex-col justify-end p-8"
      (click)="furntureProductList()"
    >
      <img
        src="https://api.vinmarts.in/uploads/images//image-1742560330012.jpg"
        class="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:scale-110 transition-transform duration-1000"
        alt="Banner"
        loading="lazy"
        decoding="async"
      />

      <!-- <div
        class="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"
      >
        <img
          src="./assets/images/image.png"
          class="w-auto h-auto object-cover"
          alt="Banner"
        />
      </div> -->

      <div class="relative z-10">
        <span
          class="text-[10px] font-bold tracking-[3px] text-blue-400 uppercase mb-2 block"
          >Special Offer</span
        >
        <h3 class="text-2xl font-bold text-white leading-tight mb-4">
          Renew Your Living Space
        </h3>
        <button
          class="w-full py-3 bg-white text-black text-xs font-bold rounded-xl hover:bg-blue-500 hover:text-white transition-all shadow-xl"
        >
          SHOP NOW
        </button>
      </div>
    </div>
  </div>
</div>

<section
  class="history-section px-4 py-6 bg-white rounded-md shadow-sm"
  *ngIf="History?.length"
>
  <div class="flex items-center justify-between mb-4 w-full">
    <h2 class="text-xl font-semibold">Suggested For You</h2>

    <div
      (click)="isSuggestedAtEnd ? browserAllHistory() : null"
      [ngClass]="
        isSuggestedAtEnd
          ? 'bg-indigo-600 text-white'
          : 'bg-gray-100 text-gray-500'
      "
      class="px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all duration-300 flex items-center gap-2 cursor-pointer"
    >
      <span>{{ isSuggestedAtEnd ? "View All" : "Scroll" }}</span>
      <svg
        *ngIf="!isSuggestedAtEnd"
        xmlns="http://www.w3.org/2000/svg"
        class="h-3 w-3 animate-bounce-x"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 8l4 4m0 0l-4 4m4-4H3"
        />
      </svg>
    </div>
  </div>

  <div
    #suggestedScroll
    (scroll)="onSuggestedScroll($event)"
    class="suggested flex gap-4 overflow-x-auto scroll-smooth pb-4 no-scrollbar"
  >
    <div
      *ngFor="let product of History"
      class="min-w-[180px] max-w-[180px] bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 p-3 flex flex-col"
    >
      <div class="h-36 flex items-center justify-center mb-2">
        <img
          [src]="catProductimgUrl + product.images[0]"
          class="object-contain h-full w-full cursor-pointer"
          alt="product"
          loading="lazy"
          decoding="async"
          (click)="getProductById(product?._id)"
        />
      </div>

      <p class="text-sm font-medium line-clamp-2 min-h-[2.6em] mb-2">
        {{ product.productDetails.productName }}
      </p>

      <div class="text-base font-semibold text-gray-900 mt-auto">
        ₹{{ product.priceInventoryShippingInfo.sellingPrice }}
      </div>
    </div>
  </div>
</section>

<div class="my-12 px-4 md:px-8" *ngIf="recentProducts?.length > 0">
  <div class="flex items-center justify-between mb-8 w-full">
    <div class="flex items-center gap-3">
      <div class="h-10 w-1.5 bg-indigo-600 rounded-full"></div>
      <div>
        <h2 class="text-2xl font-black text-gray-900 leading-none">
          Pick up where you left off
        </h2>
        <p class="text-sm text-gray-500 font-medium mt-1">
          Items from your recent browsing
        </p>
      </div>
    </div>

    <div
      (click)="isAtEnd ? browserAllHistory() : null"
      [ngClass]="
        isAtEnd
          ? 'bg-indigo-600 text-white scale-110 shadow-md border-indigo-600'
          : 'bg-slate-100 text-slate-500 border-transparent'
      "
      class="ml-auto px-5 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all duration-500 flex items-center gap-2 cursor-pointer border"
    >
      <span>{{ isAtEnd ? "View All History" : "Scroll" }}</span>
      <svg
        *ngIf="!isAtEnd"
        xmlns="http://www.w3.org/2000/svg"
        class="h-3 w-3 animate-bounce-x"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 8l4 4m0 0l-4 4m4-4H3"
        />
      </svg>
      <svg
        *ngIf="isAtEnd"
        xmlns="http://www.w3.org/2000/svg"
        class="h-3 w-3"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </div>
  </div>

  <div
    #scrollContainer
    (scroll)="onScroll($event)"
    class="flex overflow-x-auto gap-8 pb-10 no-scrollbar items-center scroll-smooth"
  >
    <div
      *ngFor="let item of recentProducts; let i = index"
      class="flex-shrink-0 w-44 md:w-52 group cursor-pointer"
      (click)="getProductById(item._id)"
    >
      <div class="relative mb-4">
        <div
          class="aspect-square rounded-[2.5rem] bg-slate-50 border border-slate-100 flex items-center justify-center p-6 shadow-sm group-hover:shadow-xl group-hover:-translate-y-2 transition-all duration-500"
        >
          <img
            [src]="catProductimgUrl + item?.images[0]"
            class="w-full h-full object-contain rounded-lg mix-blend-multiply"
            loading="lazy"
            decoding="async"
          />
          <div
            class="absolute -bottom-2 right-4 bg-indigo-600 text-white p-2 rounded-2xl opacity-0 group-hover:opacity-100 transition-all shadow-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="space-y-1">
        <h3 class="text-sm font-bold text-gray-800 line-clamp-1">
          {{ item.productDetails?.productName }}
        </h3>
        <div class="flex items-center justify-between">
          <span class="text-base font-extrabold text-gray-900"
            >₹{{ item?.priceInventoryShippingInfo?.sellingPrice }}</span
          >
          <span
            class="text-[10px] font-bold text-indigo-500 tracking-tighter uppercase"
            >View Again</span
          >
        </div>
      </div>
    </div>

    <div
      class="flex-shrink-0 w-44 h-44 border-2 border-dashed border-slate-200 rounded-[2.5rem] flex flex-col items-center justify-center transition-all duration-300 cursor-pointer group"
      [ngClass]="
        isAtEnd
          ? 'bg-indigo-600 border-indigo-600 text-white shadow-xl'
          : 'bg-white text-slate-400 hover:border-indigo-300 hover:text-indigo-400'
      "
      (click)="browserAllHistory()"
    >
      <div class="relative">
        <svg
          *ngIf="!isAtEnd"
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8 mb-2 animate-bounce-x"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 8l4 4m0 0l-4 4m4-4H3"
          />
        </svg>
        <svg
          *ngIf="isAtEnd"
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8 mb-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <span class="text-[11px] font-black tracking-widest uppercase">
        {{ isAtEnd ? "View All" : "Scroll" }}
      </span>
    </div>
  </div>
</div>
